import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import constants from "../../../constants";
import TableDropdownAndPagination from "../../../services/TableDropdownAndPagination";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
import GlobalViewFileModal from "../../../services/GlobalViewFileModal";
import { openNewTabWithId, redirectUrl } from "../../../services/GlobalUrls";
import { sortByVisitDateDesc } from "../../../services/GlobalSortByVisitDate";
import ExportButtons from "../SkeletonLoader/ExportButtons";
import TableNewPaginanation from "../../../services/TableNewPaginanation";
const DailyLogsList = ({ dailyLogsStatus, ...props }) => {
  const [dailylogs, SetDailyLogs] = useState([]);
  const [setRecordLen] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [dataLen] = useState(0);
  const [setFilter] = useState("");
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");

  let totalPages = Math.ceil(dataLen / recordsPerPage);


 useEffect(() => {
  const filterDailyLogs = props.dailylogs?.filter(
    (dailyLogs) =>
      dailyLogs.daily_logs_status ===
      (dailyLogsStatus ? dailyLogsStatus : "Pending")
  );

  SetDailyLogs(sortByVisitDateDesc(filterDailyLogs || []));
  setCurrentPage(1); // optional but recommended
}, [props.dailylogs, dailyLogsStatus]);


  const startIndex =
  recordsPerPage === "all"
    ? 0
    : (currentPage - 1) * recordsPerPage;

const endIndex =
  recordsPerPage === "all"
    ? filterRows.length
    : startIndex + recordsPerPage;


  const handleLeft = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleRight = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const visiblePages = 4;

  const renderPageNumbers = () => {
    const pageNumbers = [];
    let startPage = currentPage - Math.floor(visiblePages / 2);
    let endPage = currentPage + Math.floor(visiblePages / 2);

    if (startPage < 1) {
      startPage = 1;
      endPage = Math.min(totalPages, visiblePages);
    }

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, totalPages - visiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={i === currentPage ? "active" : ""}
          onClick={() => {
            setCurrentPage(i);
            setFilter("");
          }}
        >
          <Link to="#">{i}</Link>
        </li>
      );
    }

    return pageNumbers;
  };

  const handleDropDown = (value) => {
    setRecordLen(value);
    setRecordsPerPage(value);
    setCurrentPage(1);
  };
  const viewFileModal = (url, fileName) => {
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      setFileUrl(url);
      setFileName(fileName);
    } else {
      redirectUrl(url);
    }
  };

  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };

  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };

  const viewDailyLogData = (dailyLog) => {
    const id = dailyLog.cnd_daily_logs_id;
    if (id) {
      sessionStorage.setItem("dailyLogViewId", String(id));
      sessionStorage.setItem("dailyLogViewMode", "true");
      redirectUrl("/view-daily-log");
    }
  };

  //   Filter - Start
  const [inputValue, setInputValue] = useState("");
  const matchesSearchText = (dailyLog) => {
    const searchText = inputValue.toLowerCase();
    return (
      dailyLog.cnd_daily_logs_created_date.toLowerCase().includes(searchText) ||
      dailyLog.cnd_daily_logs_firstname.toLowerCase().includes(searchText) ||
      dailyLog.cnd_daily_logs_lastname.toLowerCase().includes(searchText) ||
      dailyLog.cnd_daily_logs_date.toLowerCase().includes(searchText)
    );
  };

  // Filter applied jobs based on the search text
  const filterRows = dailylogs ? dailylogs.filter(matchesSearchText) : [];
  //   Filter - End

  const onPageChange = (page, pageSize = recordsPerPage) => {
  setCurrentPage(page);
  setRecordsPerPage(pageSize);
};

const prepareDailyLogsExportData = (data) => {
  if (!data || data.length === 0) return [];

  return data.map((log, index) => ({
    "Sr.No.": index + 1,
    "Date & Time": log.cnd_daily_logs_created_date || "-",
    "Service User Name":
      (log.cnd_daily_logs_firstname || "") +
      " " +
      (log.cnd_daily_logs_lastname || ""),
    "Date of Visit": log.cnd_daily_logs_date || "-",
    "Status": log.daily_logs_status || "-"
  }));
};
const exportData = React.useMemo(() => {
  return prepareDailyLogsExportData(filterRows);
}, [filterRows]);



  return (
    <React.Fragment>
      <div className="m-b30 wrapper" >
        {/* Search Start */}
<div className="container">
  <div className="row align-items-center">

    {/* LEFT – Export Buttons */}
    <div className="col-sm-8 d-flex align-items-center">
      {/* <ExportButtons
        data={exportData}
        fileName={`Daily_Logs_${dailyLogsStatus || "Pending"}`}
        buttons={true}
      /> */}
    </div>

    {/* RIGHT – Search */}
    <div className="col-sm-4 mt-2">
      <div className="form-group form-group-default">
        <input
          type="text"
          className="form-control"
          placeholder="Search here"
          style={{ height: "40px" }}
          onInput={(e) => setInputValue(e.target.value)}
        />
      </div>
    </div>

  </div>
</div>

        {/* Search End */}

        <div className="courses-section">
          <table className="courses-table">
          <thead className="thead-dark">
            <tr>
              {/*<th  className="col-1 text-center" scope="col">Sr. No</th>*/}
              <th className="col-3 text-center" scope="col">
                Date & Time
              </th>
              {/*<th  className="col-2 text-center" scope="col">Email</th>*/}
              <th className="col-3 text-center" scope="col">
                Service User Name
              </th>
              <th className="col-3 text-center" scope="col">
                Date of Visit
              </th>
              <th className="col-3 text-center" scope="col">
                Uploaded Document
              </th>
              <th className="col-3 text-center" scope="col">
                Action
              </th>
              {/*<th  className="col-1 text-center" scope="col">Action</th>*/}
            </tr>
          </thead>
          <tbody id="myTable">
            {filterRows &&
              filterRows.length > 0 &&
              filterRows.slice(startIndex, endIndex).map((daily_log, i) => (
                <tr key={i}>
                  {/*<td className="col-1 text-center" scope="row">
                    {i + 1}
              </td>*/}
                  <td className="col-4 text-center">
                    {daily_log.cnd_daily_logs_created_date}
                  </td>
                  <td className="col-3 text-center" scope="row">
                    {daily_log.cnd_daily_logs_firstname +
                      " " +
                      daily_log.cnd_daily_logs_lastname}
                  </td>
                  {/*<td  className="col-2" scope="col">{daily_log.users_email}</td>*/}

                  <td className="col-3 text-center" scope="row">
                    {daily_log.cnd_daily_logs_date}
                  </td>

                  <td className="col-3 text-center" scope="col">
                    {daily_log.cnd_daily_logs_upload_file ? (
                      <a
                        rel="noopener noreferrer"
                        download
                        onClick={() =>
                          viewFileModal(
                            constants.IMAGE_URL +
                              daily_log.cnd_daily_logs_upload_file_folder_path +
                              daily_log.cnd_daily_logs_upload_file
                          )
                        }
                        className={
                          "btn btn-" +
                          (daily_log.cnd_daily_logs_upload_file.endsWith(
                            ".png"
                          ) ||
                          daily_log.cnd_daily_logs_upload_file.endsWith(
                            ".jpg"
                          ) ||
                          daily_log.cnd_daily_logs_upload_file.endsWith(
                            ".jpeg"
                          ) ||
                          daily_log.cnd_daily_logs_upload_file.endsWith(".pdf")
                            ? "dark"
                            : "primary") +
                          " btn-sm text-white"
                        }
                      >
                        <i
                          className={
                            "fa fa-" +
                            (daily_log.cnd_daily_logs_upload_file.endsWith(
                              ".png"
                            ) ||
                            daily_log.cnd_daily_logs_upload_file.endsWith(
                              ".jpg"
                            ) ||
                            daily_log.cnd_daily_logs_upload_file.endsWith(
                              ".jpeg"
                            ) ||
                            daily_log.cnd_daily_logs_upload_file.endsWith(
                              ".pdf"
                            )
                              ? "eye" //"eye"
                              : "download")
                          }
                        ></i>
                      </a>
                    ) : (
                      " - "
                    )}
                  </td>
                  {dailyLogsStatus == "Pending" && (
                    <td className="col-3 text-center" scope="col">
                      {" "}
                      <button
                        className="btn btn-primary text-white"
                        onClick={() =>
                          openNewTabWithId(
                            daily_log.cnd_daily_logs_id,
                            "/update-daily-logs",
                            ""
                          )
                        }
                      >
                        Complete
                      </button>
                    </td>
                  )}
                  {dailyLogsStatus == "Completed" && (
                    <td className="col-3 text-center" scope="col">
                      <button
                        className="btn btn-primary btn-sm text-white"
                        title="View Daily Log Details"
                        onClick={() => viewDailyLogData(daily_log)}
                      >
                        <i className="fa fa-eye"></i> View
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            {dailylogs.length == 0 && (
              <tr>
                <td colSpan="100"className="text-center">No Daily Logs Found.</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
        {dailylogs && (
          <TableNewPaginanation
            totalItems={filterRows.length}
  pageSize={recordsPerPage}
  currentPage={currentPage}
  onPageChange={onPageChange}
  isDropdown={true}
  isPaggination={true}
          />
        )}
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        // fileName={fileName}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        title={"Daily Logs - Uploaded Documents"}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    dailylogs: state.dailylogs.dailylogs,
  };
};

export default connect(mapStateToProps)(DailyLogsList);
